exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "cu-icon.styled-link-icon {\n  color: #bec3c7 !important;\n}\ncu-icon.styled-link-icon svg {\n  width: 12px !important;\n  height: 12px !important;\n}\n", ""]);

